import { createAction, createSlice } from "@reduxjs/toolkit";
import type { LoginFormErrors } from "./types";

export const USER_LOGIN_REQUEST = "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST";
export const USER_LOGIN_REQUEST_SUCCESS =
  "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST_SUCCESS";
export const USER_LOGIN_REQUEST_FAILURE =
  "API/ENTITIES/USER_LOGIN/USER_LOGIN_REQUEST_FAILURE";

interface LoginState {
  isProcessing: boolean;
  isSuccess: boolean;
  errors: LoginFormErrors;
}

interface LoginFailureAction {
  type: typeof USER_LOGIN_REQUEST_FAILURE;
  error?: {
    error_description?: string;
  };
}

export const initialState: LoginState = {
  isProcessing: false,
  isSuccess: false,
  errors: {}
};

export const loginRequested = createAction(USER_LOGIN_REQUEST);
export const loginSucceeded = createAction(USER_LOGIN_REQUEST_SUCCESS);
export const loginFailed = createAction(USER_LOGIN_REQUEST_FAILURE);

export const loginRequestTypes = [
  loginRequested.type,
  loginSucceeded.type,
  loginFailed.type
];

const loginSlice = createSlice({
  name: "loginPage",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loginRequested, state => {
        state.errors = {};
        state.isProcessing = true;
      })
      .addCase(loginSucceeded, state => {
        state.isProcessing = false;
        state.isSuccess = true;
      })
      .addCase(
        USER_LOGIN_REQUEST_FAILURE,
        (state, action: LoginFailureAction) => {
          const message = action.error?.error_description;

          state.isProcessing = false;
          state.errors = {
            email: message,
            password: message
          };
        }
      );
  }
});

export default loginSlice.reducer;
